import { Component } from '@angular/core';
import { SharedModule } from '../../../_shared/shared.module';

@Component({
  selector: 'app-courtesy-page',
  templateUrl: './courtesy-page.component.html',
  styleUrls: ['./courtesy-page.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class CourtesyPageComponent {
  title = 'Sito in manutenzione!';
  subtitle =
    'Stiamo lavorando per migliorare il servizio. Saremo di nuovo attivi entro breve.';

  reload() {
    location.assign(location.origin);
  }
}
